module.exports = __webpack_public_path__ + "img/arj.2fe921ee.svg";